import React from 'react';
import FashionIcon from '../FashionIcon';

export default function NextArrow(props) {
  const { className, style, onClick, a11yProps, iconCssName } = props;
  return (
    <button type="button" className={className} onClick={onClick} aria-label="move to next card" {...a11yProps}>
      <FashionIcon name="caret_right" iconCssName={iconCssName}/>
    </button>
  );
}
